<a (click)="downloadPod()">
    <i class="fa fa-download"></i>
    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.events.pod-upload.download'}]"></span>
</a>
